export const collectImportModel = [
  {
    Nome: "Cliente Exemplo (Apague ou reescreva essa linha)",
    Email: "email@exemplo.com (Apague ou reescreva essa linha)",
    Cep: "22250040",
    Logradouro: "Praia de Botafogo",
    Numero: "501",
    Complemento: "Sala 999",
    Bairro: "Botafogo",
    Cidade: "Rio de Janeiro",
    Estado: "RJ",
    // "Horario da Loja": "09h - 18:45h",
    "Coleta Fixa": "sim | nao (Escolha uma opcao)",
    "Horario Inicial": "09:15",
    "Horario Final": "17:45"
  }
];
